import { createSlice } from '@reduxjs/toolkit';

const initialState={
    playlist:null
}
export const  playlistSlice = createSlice({
  name: ' playlist',
  initialState,
  reducers: {

    
      
      setPlaylist: (state, action) => {
        state.playlist = action.payload;
        
      },
      setLogoutPlaylist: (state,action)=>{
      state.playlist=null
    }
  },
});

export const {  setPlaylist,setLogoutPlaylist} = playlistSlice.actions;

export default  playlistSlice.reducer;
